import { redirect } from 'react-router-dom'
import { jwtDecode } from 'jwt-decode'
import { toast } from 'react-toastify'
import { X } from 'lucide-react'

export const getTokenData = () => {
  const tokenFromStorage = localStorage.getItem('token')
  if (!tokenFromStorage) {
    toast.error('Session expired. Please login again.', {
      icon: <X color='white' />,
      style: { color: 'white' },
    })
    throw redirect('/login')
  }
  const { exp, role, email } = jwtDecode(tokenFromStorage)
  return { exp, role, tokenFromStorage, email }
}

export const ProtectedRoute = async ({ requiredRole }) => {
  try {
    // check expiry token
    const { exp, tokenFromStorage } = getTokenData()
    const currentTime = Date.now() / 1000
    if (exp < currentTime) {
      localStorage.removeItem('token')
      localStorage.removeItem('roomId')
      localStorage.removeItem('ytToken')
      toast.error('Session expired. Please login again.', {
        icon: <X color='white' />,
        style: { color: 'white' },
      })
      throw redirect('/login')
    }
    const res = await fetch(
      `${process.env.REACT_APP_SERVER_SOCKET}/api/user/verify-token`,
      {
        headers: {
          Authorization: `Bearer ${tokenFromStorage}`,
        },
      }
    )
    if (!res.ok) {
      localStorage.removeItem('token')
      localStorage.removeItem('roomId')
      localStorage.removeItem('ytToken')
      throw redirect('/login')
    }
    const data = await res.json()
    if (requiredRole && data.role !== requiredRole) {
      throw redirect('/')
    }
    return null
  } catch (error) {
    localStorage.removeItem('token')
    localStorage.removeItem('roomId')
    localStorage.removeItem('ytToken')
    toast.error('Session expired. Please login again.', {
      icon: <X color='white' />,
      style: { color: 'white' },
    })
    throw redirect('/login')
  }
}
